import * as React from 'react';
const PercentageIcon = (props: any) => {
  const { fillColor = '#009F66' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
      <rect width={16} height={16} x={0.5} fill={fillColor} rx={8} />
      <path
        fill="#fff"
        d="M6.25 7.5c-.483 0-.896-.17-1.237-.513A1.686 1.686 0 0 1 4.5 5.75c0-.483.17-.896.513-1.237A1.686 1.686 0 0 1 6.25 4c.483 0 .896.17 1.237.513.342.341.513.754.513 1.237 0 .483-.17.896-.513 1.237A1.686 1.686 0 0 1 6.25 7.5Zm0-1a.723.723 0 0 0 .531-.219A.723.723 0 0 0 7 5.75a.723.723 0 0 0-.219-.531A.723.723 0 0 0 6.25 5a.723.723 0 0 0-.531.219.723.723 0 0 0-.219.531c0 .208.073.385.219.531a.723.723 0 0 0 .531.219Zm4.5 5.5c-.483 0-.896-.17-1.238-.512A1.686 1.686 0 0 1 9 10.25c0-.483.17-.896.512-1.238A1.686 1.686 0 0 1 10.75 8.5c.483 0 .896.17 1.238.512.341.342.512.755.512 1.238s-.17.896-.512 1.238A1.686 1.686 0 0 1 10.75 12Zm0-1a.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531.723.723 0 0 0-.219-.531.723.723 0 0 0-.531-.219.723.723 0 0 0-.531.219.723.723 0 0 0-.219.531c0 .208.073.385.219.531a.723.723 0 0 0 .531.219ZM5.2 12l-.7-.7L11.8 4l.7.7L5.2 12Z"
      />
    </svg>
  );
};
export default PercentageIcon;
